<template>
    <div>
      <div>
        <van-nav-bar title="提醒列表" fixed>
        </van-nav-bar>
      </div>


      <div style="margin-bottom: 45px;margin-top: 45px;">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <van-cell-group>
            <div class="van-panel__header van-hairline--bottom"
                 :style="item.isRead?'background-color: #d2d6de':''"
                 v-for="(item,index) in list"
                 :key="item.id"
                 @click="onJump(item.id,index)">
              <div class="van-panel__title">{{ item.name }}</div>
              <span class="van-panel__desc">
                 <van-row gutter="2">
                   <van-col span="6" v-for="(remind,index) in item.remind" :key="index">
                     <van-tag :style="remind.color">{{ remind.text }}</van-tag>
                   </van-col>
                 </van-row>
                <van-row gutter="20">
                  <van-col span="24">置业顾问: {{ item.employee_text }}</van-col>
                </van-row>
                <van-row gutter="20">
                  <van-col span="10">电话: {{ item.mobile }}</van-col>
                  <van-col span="8">
                    状态:
                    <status-tag :status="item.status" :status_color="item.status_color" :status_text="item.status_text"></status-tag>
                  </van-col>
                  <van-col span="6">
                    等级:
                    <labels-tag :labels="item.labels" :labels_color="item.labels_color" :labels_text="item.labels_text"></labels-tag>
                  </van-col>
                </van-row>
                <van-row gutter="20">
                  <van-col span="24">最新跟进: {{ item.log_content }}</van-col>
                </van-row>
                <van-row gutter="20" v-if="item.log_content !== item.best_log_content">
                  <van-col span="24">最佳跟进: {{ item.best_log_content }}</van-col>
                </van-row>
              </span>
              <span class="van-panel__log"><van-tag v-if="item.isRead" type="success">已查看</van-tag><div v-else>{{ item.log_time }}</div></span>
            </div>
          </van-cell-group>
        </van-list>
        <div v-if="finished" style="margin-top: 10px;margin-bottom: 10px;margin-right: 20px;">
          <van-row>
            <van-col span="12" offset="10"><van-tag style="background-color: #c9c9c9">没有更多数据</van-tag></van-col>
          </van-row>
        </div>
      </div>
    </div>
</template>

<script>
  import StatusTag from '../../components/status-tag'
  import LabelsTag from '../../components/labels-tag'
  export default {
    components:{
      StatusTag,
      LabelsTag,
    },
    data() {
      return {
        list: this.$store.state.remind.state.list,
        loading: false,
        finished: false,
        page:1,
      };
    },
    beforeRouteLeave(to, from, next) {
      let position = window.scrollY  //记录离开页面的位置
      if (position == null) position = 0
      this.$store.state.remind.state.recruitScrollY = position
      next()
    },
    watch: {
      '$route' (to, from) {
        if (to.name === 'remind') {//跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
          let recruitScrollY = this.$store.state.remind.state.recruitScrollY
          window.scroll(0, recruitScrollY)
        }
      }
    },
    methods: {
      onJump(customer_id,index) {//跳转到跟进页面
        this.$store.state.remind.state.list[index].isRead = true
        this.$router.push('customer/edit/'+customer_id+'/remind');
      },
      onClickLeft() {
        this.$router.push('/');
      },
      onLoad() {//上拉加载
        setTimeout(() => {
          this.getList();
        }, 500);
      },
      getList(){//获取列表数据
        this.loading = true;
        this.$api.post('/api/employee/remind/list', {
          page:this.page,
        }, data => {
          console.log(data)
          this.page++;
          for (let i = 0; i < data.data.length; i++) {
            this.$store.state.remind.state.list.push(data.data[i]);
          }
          this.list = this.$store.state.remind.state.list;
          this.loading = false;
          if (data.data.length < 20) {
            this.finished = true;
          }
        })
      },
    },
    created: function () {
      window.scroll(0, 0)
      if(this.page == 1){
        this.list = []
        this.$store.state.remind.state.list = [];
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/remind/index.vue